import { connect as reduxConnect } from 'react-redux';
import { Props } from '~/types/app';
import mapDispatchToProps from './mapDispatchToProps';

const connect = (Component: React.ComponentType<Props>) =>
  reduxConnect(null, mapDispatchToProps)(Component);

export default connect;
